import http from '@/utils/http'
// 获取微信用户信息
export const getWxUserInfo = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/user/wxUserInfo',
    data,
  })
}
// 用户登录
export const login = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/user/loginWithUnionId',
    data,
  })
}
// 刷新token
export const refreshSession = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/user/refreshSession',
    data,
  })
}
// 获取用户地址列表
export const listUserAddresses = (params) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/queryUserAddress',
    params,
  })
}
// 新增用户地址
export const addUserAddress = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/addUserAddress',
    data,
  })
}
// 编辑用户地址
export const updateUserAddress = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/updateUserAddress',
    data,
  })
}